<dialog #dialog class="modal">
  <div
    data-api
    class="modal-box max-w-2xl border-[3px] border-neutral bg-base-100 p-5 brutal sm:p-6"
  >
    <div class="mb-4 flex items-center gap-3">
      <h2 class="min-w-0 flex-1 truncate font-mono text-sm font-bold uppercase">
        {{ t().title }}
      </h2>
      <form method="dialog">
        <button
          class="btn btn-square btn-sm border-[3px] border-neutral bg-base-100 brutal-sm brutal-press"
          [attr.aria-label]="t().close"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      </form>
    </div>

    <p class="text-sm">{{ t().lead }}</p>

    <div class="mt-4 border-[3px] border-neutral bg-base-200 p-3">
      <p class="font-mono text-xs font-bold uppercase opacity-70">{{ t().base }}</p>
      <p class="font-mono text-sm font-bold break-all">{{ base }}</p>
      <p class="mt-1 font-mono text-xs uppercase opacity-70">{{ t().limit(callsPerHour) }}</p>
      <a
        class="mt-1 inline-flex items-center gap-1 font-mono text-xs font-bold uppercase hover:bg-primary hover:text-primary-content"
        [href]="docs"
        target="_blank"
        rel="noopener"
      >
        <span class="material-symbols-outlined text-base">description</span> {{ t().docs }}
      </a>
    </div>

    <h3 class="mt-5 font-mono text-xs font-bold uppercase">{{ t().tokens }}</h3>

    @if (loading()) {
      <span class="loading loading-bars loading-sm mt-2 text-neutral"></span>
    } @else if (held().length) {
      <ul class="mt-2 flex flex-col gap-2">
        @for (token of held(); track token.id) {
          <li data-token class="border-[3px] border-neutral bg-base-100 p-2">
            <div class="flex items-center gap-2">
              <span class="min-w-0 flex-1 truncate text-sm font-bold">{{ token.name }}</span>
              <button
                type="button"
                data-revoke
                class="btn btn-sm border-[3px] border-neutral font-bold uppercase brutal-sm brutal-press"
                [class.bg-error]="confirming() === token.id"
                [class.text-error-content]="confirming() === token.id"
                [class.bg-base-100]="confirming() !== token.id"
                [attr.aria-label]="t().revokeLabel(token.name)"
                (click)="revoke(token)"
              >
                <span class="material-symbols-outlined text-base">delete</span>
                @if (confirming() === token.id) {
                  {{ t().sure }}
                } @else {
                  <span class="hidden sm:inline">{{ t().revoke }}</span>
                }
              </button>
            </div>
            <!-- No `uppercase` here: the prefix is part of a token, and shouting it
                 would show characters it does not have. -->
            <p class="mt-1 font-mono text-xs opacity-70">
              {{ token.prefix }} · {{ t().callsMade(token.calls ?? 0) }} ·
              {{ token.lastUsedAt ? t().lastUsed(when(token.lastUsedAt)) : t().never }}
            </p>
          </li>
        }
      </ul>
    } @else {
      <p class="mt-2 font-mono text-xs uppercase opacity-70">{{ t().none }}</p>
    }

    @if (fresh(); as made) {
      <div class="mt-3 border-[3px] border-neutral bg-primary p-3 text-primary-content brutal-sm">
        <p class="font-mono text-sm font-bold break-all" data-fresh>{{ made.token }}</p>
        <div class="mt-2 flex items-center gap-2">
          <button
            type="button"
            data-copy-token
            class="btn btn-sm border-[3px] border-neutral bg-base-100 font-bold text-base-content uppercase brutal-sm brutal-press"
            (click)="copy('token')"
          >
            <span class="material-symbols-outlined text-base">
              {{ copied() === 'token' ? 'check' : 'content_copy' }}
            </span>
            {{ copied() === 'token' ? t().copied : t().copy }}
          </button>
          <span class="font-mono text-xs font-bold uppercase">{{ t().shownOnce }}</span>
        </div>
      </div>
    }

    @if (held().length >= maxTokens) {
      <p class="mt-3 font-mono text-xs uppercase opacity-70">{{ t().full(maxTokens) }}</p>
    } @else {
      <div class="mt-3 flex gap-2">
        <div class="input w-full border-[3px] border-neutral bg-base-100 brutal-sm">
          <input
            #nameField
            [placeholder]="t().namePlaceholder"
            [attr.aria-label]="t().nameLabel"
            maxlength="40"
            autocomplete="off"
            (keydown.enter)="create(nameField)"
          />
        </div>
        <button
          type="button"
          data-create
          class="btn border-[3px] border-neutral bg-primary font-bold uppercase brutal-sm brutal-press"
          [disabled]="working()"
          (click)="create(nameField)"
        >
          @if (working()) {
            <span class="loading loading-bars loading-sm"></span>
          } @else {
            {{ t().create }}
          }
        </button>
      </div>
    }

    @if (failed()) {
      <p class="mt-2 text-sm font-bold text-error">{{ t().failed }}</p>
    }

    <h3 class="mt-6 font-mono text-xs font-bold uppercase">{{ t().agents }}</h3>
    <p class="mt-1 text-sm">{{ t().agentsLead }}</p>

    <pre
      class="mt-2 max-h-56 overflow-auto border-[3px] border-neutral bg-base-200 p-3 font-mono text-xs whitespace-pre"
      >{{ prompt() }}</pre>

    <button
      type="button"
      data-copy-prompt
      class="btn mt-2 w-full border-[3px] border-neutral bg-base-100 font-bold uppercase brutal-sm brutal-press"
      (click)="copy('prompt')"
    >
      <span class="material-symbols-outlined">
        {{ copied() === 'prompt' ? 'check' : 'content_copy' }}
      </span>
      {{ copied() === 'prompt' ? t().copied : t().copyPrompt }}
    </button>
  </div>

  <form method="dialog" class="modal-backdrop">
    <button [attr.aria-label]="t().close"></button>
  </form>
</dialog>
